import CreateBtn from "components/Survey/CreateBtn";
import QuestionsSection from "components/Survey/QuestionsSection";
import React from "react";
import { useTeamContext } from "store/contexts/teamContext";

const WellnessSurvey = () => {
  const { team } = useTeamContext();

  return (
    <div>
      <div className="surveyHeaderDiv">
        <h5>
          <strong>Survey</strong>
        </h5>
        {/* Only available for Admin and Super Admin */}
        {(team?.role_id === 2 || team?.role_id === 3) && <CreateBtn />}
      </div>
      {/* Questions of active survey */}
      <QuestionsSection />
    </div>
  );
};

export default WellnessSurvey;
